import { List } from "immutable";
import React from "react";
import * as BS from "react-bootstrap";
import { connect } from "react-redux";
import { RouteComponentProps, withRouter, Link } from "react-router-dom";
import { push } from "react-router-redux";
import * as redux from "redux";
import * as Actions from "../../../actions";
import * as Comp from "../../../components";
import { Paths } from "../../../constants";
import * as Forms from "../../../forms";
import * as M from "../../../models";
import { Api } from "../../../services/Api";
import { AppState } from "../../../store";
import { PostResumeForm } from "../../careerCenter/postResume/components";

const mapStateToProps = (state: AppState, ownProps: OwnProps | undefined): ConnectedState => ({
    api: new Api(state),
    countries: state.countries.countries,
    resumes: state.careerCenter.userResumes,
});

const mapDispatchToProps = (dispatch: redux.Dispatch<AppState>): ConnectedDispatch => ({
    goto: (url: string) => dispatch(push(url)),
    notifyError: (message: string, icon?: string) => dispatch(Actions.Noti.notifyError(message, icon)),
    notifyInfo: (message: string, icon?: string) => dispatch(Actions.Noti.notifyInfo(message, icon)),
    notifySuccess: (message: string, icon?: string) => dispatch(Actions.Noti.notifySuccess(message, icon)),
});

type OwnProps = RouteComponentProps<{
    guid: string;
}> & {
};

interface ConnectedState {
    api: Api;
    countries: List<M.Country.Country>;
    resumes: List<M.CareerCenter.Resume>;
}

interface ConnectedDispatch {
    goto: (url: string) => void;
    notifyError: (message: string, icon?: string) => void;
    notifyInfo: (message: string, icon?: string) => void;
    notifySuccess: (message: string, icon?: string) => void;
}

interface OwnState {
    errors: string[];
}

type CompinedProps = ConnectedState & ConnectedDispatch & OwnProps;

class EditResumeComponent extends Comp.Base.BaseComponent<CompinedProps, OwnState> {

    private _form: PostResumeForm | null;

    public constructor(props: any) {
        super(props);
        this.state = {
            errors: [],
            loading: false,
        };
    }

    public async componentDidMount() {
        this._isMounted = true;

        const guid = this.props.match.params.guid;
        if (!guid) {
            this.props.notifyError("Invalid resume identifier");
            this.props.goto(Paths.User.CareerCenter.Resumes);
            return;
        }

        // get from state if available
        if (this.props.resumes.size && this._form) {
            const resume = this.props.resumes.find((x) => x !== undefined && x.guid.toLowerCase() === guid.toLowerCase());
            if (resume)
                this._form.setFormDataFromResume(resume);
        }
        else
            this.toggleLoading(true);

        // load previously entered resume
        const qp = { queryParams: { guid } };
        const result = await this.props.api.get<M.CareerCenter.Resume>(Api.endpoints.users.careerCenter.resume, qp);

        if (!this._isMounted)
            return;

        if (result.isSuccess && result.data) {
            if (this._form)
                this._form.setFormDataFromResume(result.data);
        }
        else {
            const errors =  M.Result.Result.errorsOrMessage(result);
            this.setState({ ...this.state, errors });
        }

        this.toggleLoading(false);
    }

    public componentWillUnmount() {
        this._isMounted = false;
    }

    public render() {
        let details = null;

        if (this.state.errors.length) {
            details = <BS.Alert bsStyle="warning">
                <h3>The requested resume could not be retrieved.</h3>
                <ul>
                    {this.state.errors.map((e, i) => (<li key={i}>{e.toString()}</li>))}
                </ul>
            </BS.Alert>;
        }
        else {
            details = <PostResumeForm
                api={this.props.api}
                cancelLink={Paths.User.CareerCenter.Resumes}
                countries={this.props.countries}
                includeSubscribe={false}
                isUpdate
                onSubmit={(model, body) => this.onSubmit(model, body)}
                ref={(ref) => this._form = ref}
            />;
        }

        return <Comp.Page.PublicPage pageTitle="Edit resume" style={{position: "relative", minHeight: "300px"}}>
            <Comp.Generic.LoadingSpinner show={this.state.loading} />

            <h1>
                <Link to={Paths.User.Account}>Your Account</Link> &raquo;{" "}
                <Link to={Paths.User.CareerCenter.Resumes}>Your CV{this.props.resumes.size === 1 ? "/Resume" : "s/Resumes"}</Link> &raquo;{" "}
                Edit
            </h1>

            {details}
        </Comp.Page.PublicPage>;
    }

    private async onSubmit(model: Forms.CareerCenter.PostResumeData, body: any) {
        if (!this._form)
            return;

        if (!this._form.state.modelChanged) {
            this.props.goto(Paths.User.CareerCenter.Resumes);
            return;
        }
        else {
            this._form.toggleProcessing(true);

            body.guid = this.props.match.params.guid;
            const result = await this.props.api.post<M.CareerCenter.Resume>(Api.endpoints.users.careerCenter.resume, { body: JSON.stringify(body) });

            if (!this._isMounted || !this._form)
                return;

            this._form.toggleProcessing(false);

            if (result.isSuccess && result.data) {
                this.props.notifySuccess(`Resume <strong>${result.data.title}</strong> has been successfully updated.`);
                this.props.goto(Paths.User.CareerCenter.Resumes);
            }
            else {
                this._form.setFormErrors(M.Result.Result.errorsOrMessage(result), undefined, true);
            }
        }
    }
}

export const EditResume: React.ComponentClass<OwnProps> = connect(mapStateToProps, mapDispatchToProps)(withRouter(EditResumeComponent) as any);



// WEBPACK FOOTER //
// ./src/containers/user/careerCenter/EditResume.tsx